import { jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect, useContext } from "react";
const LanguageContext = createContext({
  t: (key, defaultValue) => defaultValue || key,
  loaded: false,
  currentLanguage: "en-GB"
});
const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
const LanguageProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("en-GB");
  useEffect(() => {
    const initLanguage = () => {
      try {
        if (window.Joomla && window.Joomla.Text) {
          setLoaded(true);
          const joomlaLang = document.documentElement.lang || "en-GB";
          setCurrentLanguage(joomlaLang);
        } else {
          const checkJoomla = setInterval(() => {
            if (window.Joomla && window.Joomla.Text) {
              clearInterval(checkJoomla);
              setLoaded(true);
              const joomlaLang = document.documentElement.lang || "en-GB";
              setCurrentLanguage(joomlaLang);
            }
          }, 100);
          setTimeout(() => {
            clearInterval(checkJoomla);
            if (!loaded) {
              setLoaded(true);
            }
          }, 5e3);
        }
      } catch (error) {
        console.error("Error initializing language system:", error);
        setLoaded(true);
      }
    };
    initLanguage();
  }, [loaded]);
  const t = (key, defaultValue, ...args) => {
    try {
      if (window.Joomla && window.Joomla.Text && window.Joomla.Text._) {
        let translation = window.Joomla.Text._(key, defaultValue);
        if (translation === key && defaultValue) {
          translation = defaultValue;
        }
        if (args.length > 0) {
          const firstArg = args[0];
          if (args.length === 1 && typeof firstArg === "object" && !Array.isArray(firstArg) && firstArg !== null) {
            Object.keys(firstArg).forEach((key2) => {
              const value = firstArg[key2];
              translation = translation.replace(new RegExp(`\\{\\{${key2}\\}\\}`, "g"), String(value));
            });
          } else {
            args.forEach((replacement, index) => {
              translation = translation.replace(new RegExp(`%${index + 1}\\$[sd]`, "g"), String(replacement));
              translation = translation.replace(/%[sd]/, String(replacement));
            });
          }
        }
        return translation;
      }
    } catch (error) {
      console.warn(`Translation error for key "${key}":`, error);
    }
    let fallback = defaultValue || key;
    if (args.length > 0) {
      const firstArg = args[0];
      if (args.length === 1 && typeof firstArg === "object" && !Array.isArray(firstArg) && firstArg !== null) {
        Object.keys(firstArg).forEach((key2) => {
          const value = firstArg[key2];
          fallback = fallback.replace(new RegExp(`\\{\\{${key2}\\}\\}`, "g"), String(value));
        });
      } else {
        args.forEach((replacement, index) => {
          fallback = fallback.replace(new RegExp(`%${index + 1}\\$[sd]`, "g"), String(replacement));
          fallback = fallback.replace(/%[sd]/, String(replacement));
        });
      }
    }
    return fallback;
  };
  const contextValue = {
    t,
    loaded,
    currentLanguage
  };
  return /* @__PURE__ */ jsx(LanguageContext.Provider, { value: contextValue, children });
};
export {
  LanguageProvider,
  useLanguage
};
//# sourceMappingURL=language-context.js.map
